import { Common, ApiBind } from './common.model';

export class User extends Common {
  constructor(user: Partial<User>) {
    super(user);
    this.id = user.id ?? this.id;
    this.name = user.name ?? this.name;
    this.displayName = user.displayName ?? this.displayName;
    this.status = user.status ?? this.status;
    this.roleID = user.roleID ?? this.roleID;
    this.updatedAt = user.updatedAt ?? this.updatedAt;
    this.emailAddress = user.emailAddress ?? this.emailAddress;
  }

  @ApiBind({ column: 'id' })
  id: string;

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'display_name' })
  displayName: string;

  @ApiBind({ column: 'status' })
  status: number;

  @ApiBind({ column: 'role_id' })
  roleID: number;

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;

  @ApiBind({ column: 'email_address' })
  emailAddress: string;

  /**
     * toDeleteItemJSON 削除用のJSONオブジェクトを作成
     * @returns {object}
     */
  public toDeleteItemJSON() {
    return { id: this.convertJSONObject(this.id), updated_at: this.convertJSONObject(this.updatedAt) };
  }
}
